import React from "react";
import styled from "styled-components";
import { themevals } from "theme/themevals";

export const Div = styled.div` 
  display: block;
  height: 0;
  width: 100%;
  margin-top: 30px;
  margin-bottom: 30px;   
  border-bottom: 1px solid ${themevals.colors.inputOutline}
`;


export default function Separator({children, styles}: any) {

  return (
    <Div />
  );
}